export default {"src":"/_next/static/media/ticket-fill.eb86e80a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};